import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=601add8a"
import script from "./Publicity.vue?vue&type=script&lang=js"
export * from "./Publicity.vue?vue&type=script&lang=js"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=601add8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8bd846dc4b65c5b8a85fd68976b17e9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports